import * as PIXI from "pixi.js";
import { OrientationType } from "../constant/RendererConstants";
/**
 * Viewport.ts
 */
export class Viewport {
    constructor(width, safeWidth, height, safeHeight, orientation) {
        this.width = width;
        this.safeWidth = safeWidth;
        this.height = height;
        this.safeHeight = safeHeight;
        this.orientation = orientation;
    }
    isLandscape() {
        return this.orientation == OrientationType.LANDSCAPE;
    }
    isPortrait() {
        return this.orientation == OrientationType.PORTRAIT;
    }
    getOrientation() {
        return this.orientation;
    }
    getGameSize() {
        return new PIXI.Point(this.width, this.height);
    }
}
//# sourceMappingURL=Viewport.js.map